import React, {useContext, useState} from 'react';
import styles from './index.module.scss';
import {Row, Space} from 'antd';
import {ProFormContext} from '../../context';
import classNames from 'classnames';
import {Gutter} from 'antd/lib/grid/row';
import {LinkButton} from '../../../../Features/Buttons/LinkButton';

export interface FormGroupProps {
    title?: React.ReactNode;
    children: React.ReactNode;
    extra?: React.ReactNode;
    editable?: boolean;
    className?: string;
    bodyClassName?: string;
    style?: React.CSSProperties;
    gutter?: Gutter | [Gutter, Gutter];
}

export default function FormGroup({
    title,
    children,
    extra,
    editable,
    className,
    bodyClassName,
    gutter,
    style,
}: FormGroupProps) {
    const context = useContext(ProFormContext);
    const [disabled, setDisabled] = useState(context.disabled);

    return (
        <ProFormContext.Provider
            value={{
                ...context,
                disabled: disabled === undefined ? context.disabled : disabled,
            }}>
            <div className={classNames(styles.root, className)} style={style}>
                <div className={styles.header}>
                    <div className={styles.title}>{title}</div>

                    <Space style={{paddingLeft: 30}}>
                        {editable && disabled && (
                            <LinkButton onClick={() => setDisabled(false)}>
                                修改
                            </LinkButton>
                        )}

                        {extra}
                    </Space>
                </div>

                <div className={classNames(styles.body, bodyClassName)}>
                    <Row gutter={gutter}>{children}</Row>
                </div>
            </div>
        </ProFormContext.Provider>
    );
}
